<div class="parametre-donnees-dt-wrap parametre-donnees-dt__table-shell">
  <div class="table-responsive" [attr.aria-busy]="busy">
    <table class="table table-hover parametre-donnees-dt-table mb-0">
      <thead class="custom-header">
        <tr>
          <th *ngFor="let c of columns" [style.width]="c.width">{{ c.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows; trackBy: trackByIdx">
          <td *ngFor="let c of columns" [ngClass]="{ 'pd-dt-json-cell': isJsonPrettyKey(c.key), 'pd-dt-wrap-cell': c.key === 'ancienneValeur' || c.key === 'nouvelleValeur' }">
            {{ cellText(row, c.key) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="!busy && rows.length === 0" class="text-center text-muted py-4 small">
    {{ emptyMessage }}
  </div>
</div>
